import React from "react";
import { useParams } from "react-router";
import CreateUserContainer from "../../containers/users/CreateUser";

const CreateUserPage = () => {
	const { id } = useParams();

	return <CreateUserContainer userId={id} />;
};

export default CreateUserPage;
